import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { Alert as AlertSvelte } from '@glance-design/alert';

export const Alert = (props) => {
  const defineProps = {
    size: props.size,
    severity: props.severity,
    variant: props.variant,
    heading: props.heading,
    closable: props.closable,
    fadeTimeout: props.fadeTimeout,
    onClose: props.onClose
  };

  return (
    <Svelte component={AlertSvelte} {...defineProps} />
  );
};
